<div class="mct-flex mct-row mct-justify-between mct-items-stretch"  >
  <h2>{{ 'communications.mass-comm-message-admin.title' | translate | titlecase }}</h2>
  <div *ngIf="showDateFilter">
    <wl-date-selector appendTo="body" [(ngModel)]="startDate"></wl-date-selector>
    <span>
      {{ 'common.through' | translate }}
    </span>
    <wl-date-selector appendTo="body" [(ngModel)]="endDate"></wl-date-selector>
  </div>
</div>
<wlx-tabs #tabsContainer>
  <wlx-tab [title]="'communications.mass-comm-message-admin.analytics.title' | translate | titlecase">
    <wlx-tab
      [title]="'communications.mass-comm-message-admin.dashboard-tab-title' | translate | titlecase"
      (selected)="showDateFilter = true"
    >
      <wl-mass-comm-message-admin-analytics [startDate]="startDate" [endDate]="endDate"></wl-mass-comm-message-admin-analytics>
    </wlx-tab>
    <wlx-tab
      (selected)="showDateFilter = true"
      [title]="'communications.mass-comm-message-admin.subscription.title' | translate | titlecase"
    >
      <wl-mass-comm-subscription-tracking [startDate]="startDate" [endDate]="endDate"></wl-mass-comm-subscription-tracking>
    </wlx-tab>
  </wlx-tab>

  <wlx-tab
    #draftsTab
    [title]="'communications.mass-comm-message-admin.drafts-tab-title' | translate | titlecase"
    (selected)="showDateFilter = false"
  >
    <wl-mass-comm-message-admin-drafts></wl-mass-comm-message-admin-drafts>
  </wlx-tab>
  <wlx-tab
    #recurringTab
    [title]="'communications.mass-comm-message-admin.recurring-tab-title' | translate | titlecase"
    (selected)="showDateFilter = false"
  >
    <wl-mass-comm-message-admin-recurring></wl-mass-comm-message-admin-recurring>
  </wlx-tab>
  <wlx-tab
    #scheduledTab
    [title]="'communications.mass-comm-message-admin.scheduled-tab-title' | translate | titlecase"
    (selected)="showDateFilter = false"
  >
    <wl-mass-comm-message-admin-scheduled-messages></wl-mass-comm-message-admin-scheduled-messages>
  </wlx-tab>
  <wlx-tab
    #sentTab
    [title]="'communications.mass-comm-message-admin.sent-tab-title' | translate | titlecase"
    (selected)="showDateFilter = false"
  >
    <wl-mass-comm-message-admin-sent-messages></wl-mass-comm-message-admin-sent-messages>
  </wlx-tab>
</wlx-tabs>
